module.exports = __webpack_public_path__ + "static/media/10-7.0bedc940.mp3";